import React,{useState} from 'react';
import { Container,Row,Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import './Contact.css';
import Message from "../alert/Message";
import Slide from 'react-reveal/Slide';
function Contact() {
    const [first_name, setFirstName] = useState('');
    const [last_name, setLastName] = useState('');
    const [email, setEmail ] = useState('');
    const [phone_number, setPhoneNumber] = useState('');
    const [appointment_date, setAppointmentDate ]= useState('');

    const submitHandler = (e)=>{
        e.preventDefault();
        console.log('')
    }
    return (
        <div id="contact" className='my-5 contact'>
            <Slide bottom>
                <h3 style={{textAlign:'center'}} className="my-3"> Book Appointment</h3>
            </Slide>
            <Container>
                <Row className="my-4">
                    <Message/>
                    
                    <Col className='my-5' sm={12} md={6}>
                        <Card className='contact__card p-4 align-items-center justify-content-center'>
                            
                                <h3>Contact Information</h3>
                                
                                

                                <div className='my-2'>
                                    <span> 
                                        <i className="fa-solid fa-phone"></i> +254 112774429
                                    </span>
                                </div>

                                <div className='my-2'>
                                    <span>
                                        <i className="fa-solid fa-envelope mx-1"></i> royalsmilesclinic.com
                                    </span>
                                </div>
                                <div>

                                    <span>
                                        <i className="fa-solid fa-location-pin mx-1"></i>
                                        Lower Savanna Dakar Rd
                                        Directly Opposite GreenSpan Mall
                                    </span>
                                    
                                </div>
                                
                                
                            
                        </Card>
                    </Col>
                    <Col className='my-5 px-3' sm={12} md={6}>
                        <Form onSubmit={submitHandler}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>First Name</Form.Label>
                                <Form.Control type="text" placeholder="First Name" value={first_name} onChange={(e)=>setFirstName(e.target.value)} disabled={true} />
                                
                        
                            </Form.Group>

                            
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control type="text" placeholder="Last Name" value={last_name} onChange={(e)=>setLastName(e.target.value)} disabled={true}/>
                                
                                </Form.Group>

                            
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control type="email" placeholder="Enter email" value={email} onChange={(e)=>setEmail(e.target.value)} disabled={true} />
                                    <Form.Text className="text-muted">
                                    We'll never share your email with anyone else.
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Phone Number</Form.Label>
                                    <Form.Control type="number" placeholder="Phone Number" value={phone_number} onChange={(e)=>setPhoneNumber(e.target.value)} disabled={true}/>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Appointment Date</Form.Label>
                                    <Form.Control type="datetime-local" placeholder="Pick a date" value={appointment_date} onChange={(e)=>setAppointmentDate(e.target.value)} disabled={true}/>
                                </Form.Group>
                                
                                <Button variant="primary" type="submit"disabled={true}>
                                Submit
                                </Button>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Contact;
